module.exports = __webpack_public_path__ + "static/img/iphone3.950fb07.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/usdt2/iphone3.png
// module id = LqCf
// module chunks = 1